import { isComunidadEventoN8n } from './comunidadEventosN8n.js';

/**
 * Estado de moderación de una publicación Comunidad (admin).
 * @param {{ aprobada?: boolean, is_hidden?: boolean, isHidden?: boolean, metadata?: object|null }} row
 */
export function comunidadModeracionEstado(row) {
  const aprobada = !!(row?.aprobada);
  const hidden = !!(row?.is_hidden ?? row?.isHidden);
  const n8n = isComunidadEventoN8n(row);

  if (hidden) {
    if (aprobada) {
      return {
        key: 'hidden_from_feed',
        label: 'Oculto · en feed antes',
        title: 'Estuvo aprobada y visible; retirada u ocultada por administración.',
      };
    }
    if (n8n) {
      return {
        key: 'n8n_hidden',
        label: 'Borrador n8n oculto',
        title: 'Borrador automático n8n, nunca publicado en el feed.',
      };
    }
    return {
      key: 'hidden_never_feed',
      label: 'Oculto · nunca en feed',
      title: 'Rechazada u oculta sin haber estado publicada en el feed.',
    };
  }

  if (aprobada) {
    return {
      key: 'in_feed',
      label: 'En feed público',
      title: 'Aprobada y visible para todos en Comunidad.',
    };
  }

  if (n8n) {
    return {
      key: 'n8n_draft',
      label: 'Borrador n8n',
      title: 'Ingestado por n8n; pendiente de aprobación en Admin → Comunidad.',
    };
  }

  return {
    key: 'user_pending',
    label: 'Pendiente · borrador',
    title: 'Propuesta de usuario; aún no visible en el feed público.',
  };
}

/** Estilos de pill para tabla admin / tarjetas Comunidad. */
export function comunidadModeracionEstadoPillStyle(key, { gold, green, danger } = {}) {
  const g = gold || 'rgba(200,168,75,0.95)';
  const gn = green || 'rgba(29,158,117,0.95)';
  const d = danger || 'rgba(255,180,180,0.95)';
  const base = {
    display: 'inline-block',
    fontSize: 10,
    fontWeight: 600,
    padding: '3px 8px',
    borderRadius: 8,
    lineHeight: 1.35,
    whiteSpace: 'nowrap',
  };
  switch (key) {
    case 'in_feed':
      return {
        ...base,
        background: 'rgba(29,158,117,0.14)',
        border: '1px solid rgba(29,158,117,0.35)',
        color: gn,
      };
    case 'hidden_from_feed':
      return {
        ...base,
        background: 'rgba(255,255,255,0.06)',
        border: '1px solid rgba(255,255,255,0.18)',
        color: 'rgba(255,255,255,0.72)',
      };
    case 'hidden_never_feed':
    case 'n8n_hidden':
      return {
        ...base,
        background: 'rgba(226,75,74,0.12)',
        border: '1px solid rgba(226,75,74,0.35)',
        color: d,
      };
    case 'n8n_draft':
      return {
        ...base,
        background: 'rgba(120,160,255,0.12)',
        border: '1px solid rgba(120,160,255,0.35)',
        color: 'rgba(180,200,255,0.95)',
      };
    case 'user_pending':
    default:
      return {
        ...base,
        background: 'rgba(200,168,75,0.12)',
        border: '1px solid rgba(200,168,75,0.35)',
        color: g,
      };
  }
}
